export default "__VITE_ASSET__DRNLuRWL__"